import { HttpInterceptorFn } from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const contentType = req.headers.get('Content-Type');
  const responseType = req.responseType;
  const language = inject(LOCALE_ID);
  // Needed for some assets like svgIcons.
  if (req.url.startsWith('assets') || req.url.startsWith('./') || req.url.startsWith('../')) return next(req);

  let headers = req.headers.set('x-plantefeve-language-alpha2-code', language.substring(0, 2));

  if (contentType === 'multipart/form-data') {
    const headertsWithoutContentType = headers.delete('Content-Type');
    const apiReq = req.clone({
      headers: headertsWithoutContentType,
      responseType: responseType ?? 'json',
    });
    return next(apiReq);
  }

  headers = headers.set('Content-Type', contentType ?? 'application/json');
  const apiReq = req.clone({
    headers: headers,
    responseType: responseType ?? 'json',
  });

  return next(apiReq);
};
